var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components-list"},[_c('draggable',_vm._b({attrs:{"tag":"ul","value":_vm.list,"force-fallback":true},on:{"start":function($event){return _vm.handleStart($event, _vm.list)}}},'draggable',{
    group: { name: 'form-draggable', pull: 'clone', put: false },
    sort: false,
    animation: 180,
    ghostClass: 'moving'
  },false),_vm._l((_vm.list),function(val,index){return _c('li',{key:index,staticClass:"form-edit-widget-label",on:{"click":function($event){return _vm.$emit('handleListPush', val)}}},[_c('a',[_c('span',[_vm._v(_vm._s(val.label))])])])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }